import { environment } from '@pacifico/environments/environment';

/**
 * Esta clase se encarga de validar si el host a usar sera el mock o el host por default del environment.
 */
export class Host {
	getUrl(): string {
		return this._getUrl();
	}

	private _getUrl(): string {
		let host = environment.host;
		if (environment.mock) {
			host = environment.hostMock;
		} else if (environment.proxy) {
			const startIndex = host.indexOf('.com/') + 5;
			host = host.substring(startIndex, host.length);
		}
		return host;
	}
}

export const AUTH_LOGIN = '/login';
export const AUTH_LOGOUT = '/logout';

export interface IResponse<T> {
	status: Status;
	data: T;
}

interface Status {
	code: string;
	message: string;
}
